// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ihWc","buttons":"styles_buttons__3TCv3"};